import axios from 'axios';
import { stringify } from 'qs';
import once from 'lodash/once';
import { ExecutionCounter } from './ExecutionCounter';

const CHANNEL_CONFIGS = {
  hsbcnet: {
    payload: {
      redirect_uri: 'https://genesys.oauth2.hsbcnet',
      scope: 'openid',
    },
    tokenType: 'OPENAM',
  },
  dbbuk: {
    payload: {
      redirect_uri: 'https://login.mypurecloud.com',
      scope: 'openid profile',
    },
    tokenType: 'SESSION_TOKEN',
  },
};

export const registerAuthPlugin = once(() => {
  const getAuthCodeCounter = new ExecutionCounter(5);

  window.Genesys('registerPlugin', 'AuthProvider', (AuthProvider) => {
    clearInterval(window.authSettingsReset);
    // register getAuthCode comment to exchange session token with authcode
    AuthProvider.registerCommand('getAuthCode', async (e) => {
      const resolveIfWithinMaxCountElseReject = (resolvedData) => {
        if (!getAuthCodeCounter.isReachLimit()) {
          e.resolve(resolvedData);
        } else {
          e.reject();

          getAuthCodeCounter.resetCount();
        }
      };

      try {
        const { gacUrl, channel } =
          window.utag_data?.hsbc_chat_assistant_config ?? {};
        const normalizedChannelName = channel?.toLowerCase();
        const { payload, tokenType } =
          CHANNEL_CONFIGS[normalizedChannelName] ?? {};

        // fetch code
        const response = await axios.post(
          gacUrl,
          stringify({
            save_consent: 1,
            decision: 'allow',
            response_type: 'code',
            ...payload,
          }),
          {
            withCredentials: true,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              Token_Type: tokenType,
              channel: normalizedChannelName,
            },
          },
        );

        const { data } = response.data;

        getAuthCodeCounter.increment();

        if (data?.code) {
          e.resolve({
            authCode: data.code,
            redirectUri: payload.redirect_uri,
          });

          getAuthCodeCounter.resetCount();
        } else {
          resolveIfWithinMaxCountElseReject({
            authCode: null,
            redirectUri: payload.redirect_uri,
          });
        }
      } catch {
        resolveIfWithinMaxCountElseReject({
          authCode: null,
          redirectUri: null,
        });
      }
    });

    AuthProvider.registerCommand('reAuthenticate', (e) => {
      /**
       * Messenger will call this command when current refreshToken and/or authCode are no more valid.
       * Brand can add logic here to simply re-login and resolve this command after successful login
       * so that Messenger can get the new authCode. (In case when browser needs to reload for a login,
       * there is no need to resolve this command).
       * Note: After a successful re-login, calling the getAuthCode command is taken care internally
       * and there is no need to call it explicitly again.
       * We are resolving this to re-run getAuthCode on refreshToken failure.
       **/
      e.resolve();
    });

    /**
     * Auth getTokens - AuthProvide.command('Auth.getAuthCode')
     * Auth reAuthenticate - AuthProvide.command('Auth.reAuthenticate');
     * Auth logout - AuthProvider.command('Auth.logout')
     * Auth onLogout = AuthProvider.subscribe('Auth.loggedOut')
     */
    // Tell Messenger that your plugin is ready (mandatory)
    AuthProvider.ready();
  });
});
